document.addEventListener('DOMContentLoaded', function() {
  // Find all stats callout sections on the page
  const statsSections = document.querySelectorAll('.stats-callout');
  
  statsSections.forEach(function(statsSection) {
    // Get settings from data attributes
    const animationDuration = parseInt(statsSection.dataset.animationDuration) || 2000;
    const animationThreshold = parseInt(statsSection.dataset.animationThreshold) / 100 || 0.3;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const items = entry.target.querySelectorAll('.stats-callout__item');
          items.forEach(item => {
            item.classList.add('is-visible');
          });
  
          const statValues = entry.target.querySelectorAll('.stats-callout__value');
          statValues.forEach(stat => {
            const targetValue = parseInt(stat.dataset.value, 10);
            if (isNaN(targetValue)) return;
            
            let startTimestamp = null;
            const step = (timestamp) => {
              if (!startTimestamp) startTimestamp = timestamp;
              const progress = Math.min((timestamp - startTimestamp) / animationDuration, 1);
              stat.textContent = Math.floor(progress * targetValue).toLocaleString();
              if (progress < 1) {
                window.requestAnimationFrame(step);
              }
            };
            window.requestAnimationFrame(step);
          });
          
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: animationThreshold });
  
    observer.observe(statsSection);
  });
});